import { render, staticRenderFns } from "./TableTreatment.vue?vue&type=template&id=4e9e3532"
import script from "./TableTreatment.vue?vue&type=script&lang=js"
export * from "./TableTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports